var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6183 34.8169C30.59 34.3535 36.1433 28.7214 36.6003 21.6509C36.6897 20.2672 36.6897 18.8342 36.6003 17.4505C36.1433 10.38 30.59 4.7479 23.6183 4.28447C21.2398 4.12637 18.7566 4.1267 16.383 4.28447C9.4113 4.7479 3.858 10.38 3.40105 17.4505C3.31163 18.8342 3.31163 20.2672 3.40105 21.6509C3.56748 24.226 4.70636 26.6104 6.04716 28.6237C6.82566 30.0332 6.31188 31.7924 5.501 33.329C4.91633 34.437 4.624 34.991 4.85871 35.3912C5.09345 35.7914 5.61775 35.8042 6.66636 35.8297C8.7401 35.8802 10.1384 35.2922 11.2484 34.4737C11.878 34.0095 12.1928 33.7774 12.4097 33.7507C12.6266 33.724 13.0536 33.8999 13.9073 34.2515C14.6746 34.5675 15.5656 34.7625 16.383 34.8169C18.7566 34.9747 21.2398 34.975 23.6183 34.8169Z",
    stroke: "#F7FEFA",
    strokeOpacity: 0.85,
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25L15.5698 15.7906C15.7272 15.3185 16.169 15 16.6667 15C17.1643 15 17.6062 15.3185 17.7635 15.7906L20.8333 25M25.8333 15V25M14.1667 21.6667H19.1667",
    stroke: "#F7FEFA",
    strokeOpacity: 0.85,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.b18cd328b6d3394e0d258a6219d31d6b.svg";
export { ForwardRef as ReactComponent };